import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-card-hsia-text-with-icon.js';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="card-title" data-show="true" class="card-title">
      <h2 style="text-align:center;">Title</h2>
      <p style="text-align:center;">Description</p>
    </div>
    <div
      data-bg-item-color="#F5F5F5"
      data-border-item-radius="20"
      data-attribute="list-item"
      class="list-item"
      style="--bg-item-color: #F5F5F5; --border-item-radius: 20px;"
    >
      <a href="#" data-attribute="item" class="wrap-item">
        <div class="wrap-img-item">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab106012e33ddcb4f7adb84.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>Free Returns &amp; Exchanges</h3>
          <p>Enjoy 30-day free returnsand exchanges-shop with confidence!</p>
        </div> </a
      ><a href="#" data-attribute="item" class="wrap-item">
        <div class="wrap-img-item">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab10606f2668aa0aef2c720.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>Free Returns &amp; Exchanges</h3>
          <p>Enjoy 30-day free returnsand exchanges-shop with confidence!</p>
        </div> </a
      ><a href="#" data-attribute="item" class="wrap-item">
        <div class="wrap-img-item">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1060995337b99fc5cc740.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>Free Returns &amp; Exchanges</h3>
          <p>Enjoy 30-day free returnsand exchanges-shop with confidence!</p>
        </div> </a
      ><a href="#" data-attribute="item" class="wrap-item">
        <div class="wrap-img-item">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab1064059c2fed70fcb3331.png"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="text-item">
          <h3>Free Returns &amp; Exchanges</h3>
          <p>Enjoy 30-day free returnsand exchanges-shop with confidence!</p>
        </div>
      </a>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
